import React from 'react';
import SurveySection from '../components/SurveySection';
import HeaderBanner from '../components/HeaderBanner';

const MainPage = () => {
  return (
    <>
      {/* <HeaderBanner title='Welcome to the InnerScience Personality Test' /> */}
      <div className='main-page'>
        <SurveySection compact />
      </div>
    </>
  );
};

export default MainPage;
